import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'

interface MergeCompaniesTemplateResponse {
  downloadUrl: string
}

export const useMergeCompaniesTemplate = (
  options?: UseMutationOptions<
    MergeCompaniesTemplateResponse,
    RequestErrorType,
    RequestTypes['mergeCompaniesTemplate']
  >,
) => {
  return useMutation({
    ...companyKeys.mergeCompaniesTemplate,
    ...options,
  })
}
